import { FC, ReactNode } from "react";

import Body from "../../styles/typography/Body.styled";
import { Label } from "./styles/Label.styled";
import Radio from "./styles/Radio.styled";

interface RadioInputProps {
  name: string;
  label: ReactNode;
  disabled: boolean;
  value: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
}

const RadioInput: FC<RadioInputProps> = ({
  name,
  label,
  value,
  checked,
  onChange,
  onFocus,
  disabled = false,
}) => (
  <Label>
    <Radio
      checked={checked}
      name={name}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      disabled={disabled}
    />
    <Body>{label}</Body>
  </Label>
);

export default RadioInput;
